import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/domains/common/components/tabs"

export type ManagePositionTabId =
  | "overview"
  | "increase"
  | "decrease"
  | "collect"
  | "close"
  | "history"

export type ManagePositionTab = {
  id: ManagePositionTabId
  label: string
}

export const MANAGE_POSITION_TABS: ReadonlyArray<ManagePositionTab> = [
  { id: "overview", label: "Overview" },
  { id: "increase", label: "Add" },
  { id: "decrease", label: "Remove" },
  { id: "collect", label: "Fees" },
  { id: "close", label: "Close" },
  { id: "history", label: "History" },
]

/**
 * Tab shell for the manage-position layout.
 *
 * Consumers provide the active tab + change callback (typically wired to
 * router navigation in the composite layer) and render matching content as
 * children keyed on the tab id.
 */
export const ManagePositionTabsView = ({
  activeTab,
  onTabChange,
  tabs = MANAGE_POSITION_TABS,
  overview,
  increase,
  decrease,
  collect,
  close,
  history,
}: {
  activeTab: ManagePositionTabId
  onTabChange: (tab: ManagePositionTabId) => void
  tabs?: ReadonlyArray<ManagePositionTab>
  overview?: React.ReactNode
  increase?: React.ReactNode
  decrease?: React.ReactNode
  collect?: React.ReactNode
  close?: React.ReactNode
  history?: React.ReactNode
}) => {
  return (
    <Tabs value={activeTab} onValueChange={(value) => onTabChange(value as ManagePositionTabId)}>
      <div className="mx-auto w-full max-w-2xl">
        <TabsList>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.id} value={tab.id}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
      <TabsContent value="overview">
        <NarrowActionPanel>{overview}</NarrowActionPanel>
      </TabsContent>
      <TabsContent value="increase">
        <NarrowActionPanel>{increase}</NarrowActionPanel>
      </TabsContent>
      <TabsContent value="decrease">
        <NarrowActionPanel>{decrease}</NarrowActionPanel>
      </TabsContent>
      <TabsContent value="collect">
        <NarrowActionPanel>{collect}</NarrowActionPanel>
      </TabsContent>
      <TabsContent value="close">
        <NarrowActionPanel>{close}</NarrowActionPanel>
      </TabsContent>
      <TabsContent value="history">{history}</TabsContent>
    </Tabs>
  )
}

const NarrowActionPanel = ({ children }: { children?: React.ReactNode }) => {
  return <div className="mx-auto w-full max-w-2xl">{children}</div>
}
